import { AxiosInstance } from 'axios';
import { ServiceBaseConfig } from './Interfaces/IAccountService';
import {
  IConfigurationPlan,
  IConfigurationPlanCompanyResponse,
  ICurrency,
  IRelevantActivity,
  RegisterCompanyPayload,
  RegisterCompanyResponse,
  RegisterCompanyTransferPayload,
  RegisterSicCompanyPayload
} from './Interfaces/ICompanyRegisteringService';
export class CompanyRegisteringService {
  public static async registerCompany(
    api: AxiosInstance,
    payload: RegisterCompanyPayload,
    config: ServiceBaseConfig
  ): Promise<RegisterCompanyResponse> {
    const ddi = payload.ddi;
    const ddd = payload.phone.match(/\(\d+\)/g)?.[0].replace(/\D/g, '');
    const telephone = payload.phone
      .replace(ddd || '', '')
      .replace(/\D/g, '')
      .trim();

    const parsedPayload = {
      configuration_plan: payload.configSlug,
      currency_id: Number(payload.currency),
      ibc_primary: payload.IBCPrimaryName,
      ibc_secondary: payload.IBCSecondName,
      ibc_third: payload.IBCThirdName,
      email: payload.primaryEmail,
      ddi,
      ddd,
      telephone,
      has_relevant_activity: true,
      total_authorized_shares: Number(payload.totalAuthorizedShares),
      par_value: Number(payload.totalAuthorizedShares),
      total_issued_shares: Number(payload.totalIssuedShares),
      relevant_activity_id: Number(payload.relevantActivity)
    };

    const { data } = await api.post('/companies', parsedPayload, config);

    return data;
  }

  public static async listRelevantActivities(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<{ data: IRelevantActivity[] }> {
    const { data } = await api.get('/relevant-activities', config);

    return data;
  }

  public static async listCurrencies(api: AxiosInstance, config: ServiceBaseConfig): Promise<{ data: ICurrency[] }> {
    const { data } = await api.get('/currencies', config);

    return data;
  }

  public static async getConfigurationPlanCompany(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<{ data: IConfigurationPlan }> {
    const { data } = await api.get('/companies/configurations/plans', config);

    return data;
  }

  public static async getAccountPlanCompany(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<{ data: IConfigurationPlanCompanyResponse }> {
    const { data } = await api.get('/companies/accounts/plans', config);

    return data;
  }

  public static async registerSicCompany(
    api: AxiosInstance,
    payload: RegisterSicCompanyPayload,
    config: ServiceBaseConfig
  ): Promise<RegisterCompanyResponse> {
    const { data } = await api.post('/companies-sic', payload, config);

    return data;
  }

  public static async registerCompanyTransfer(
    api: AxiosInstance,
    payload: RegisterCompanyTransferPayload,
    config: ServiceBaseConfig
  ): Promise<any> {
    const { data } = await api.post('/companies/transfers', payload, config);

    return data;
  }

  public static async registerDirectorsCompany(
    api: AxiosInstance,
    payload: any,
    companyId: number,
    config: ServiceBaseConfig
  ): Promise<any> {
    const { data } = await api.post(`/companies/${companyId}/transfers/shareholders`, payload, config);

    return data;
  }

  public static async registerCompanyTransfersPayments(
    api: AxiosInstance,
    payload: { ignore_checkout?: boolean } | undefined,
    companyId: number,
    config: ServiceBaseConfig
  ): Promise<any> {
    const response = await api.post(`/companies/${companyId}/transfers/payments`, payload, config);

    return response;
  }
}
